// InvoicePrintService.js
import generatePrintContent from './InvoicePrintTemplate';

/**
 * Opens a new window with the invoice content and triggers the print dialog
 * @param {Object} invoiceData - The invoice data to print
 * @param {Object} options - Optional settings for printing
 */
const printInvoice = (invoiceData, options = {}) => {
    const printWindow = window.open("", "_blank");

    const invoicePrintData = {
        invoiceTitle: 'Sales Invoice',
        invoiceNo: invoiceData.invoiceNo,
        date: invoiceData.date,
        salesRepresentative: invoiceData.salesRepresentative,
        paymentMethod: invoiceData.paymentMethod,
        customerNic:invoiceData.customerNic,
        customerName: invoiceData.customerName,
        customerPhone: invoiceData.customerPhone || "No Phone Provided",
        customerAddress: invoiceData.customerAddress,
        items: invoiceData.items.map(p => ({
            name: p.name,
            quantity: p.quantity,
            unitPrice: p.unitPrice,
            totalPrice: p.totalPrice,
        })),
        total: invoiceData.total,
        discount: invoiceData.discount,
        grandTotal: invoiceData.grandTotal,
        notes: invoiceData.notes,
        serialNumber: invoiceData.serialNumber,
    };

    const printContent = generatePrintContent(invoicePrintData);

    // Write content to the new window
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Wait for the content to render before printing
    printWindow.onload = () => {
        const canvas = printWindow.document.getElementById('invoice-logo');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        // Correct logo path for React (public folder)
        img.src = '/images/logo.png';

        // Ensure logo renders before printing
        img.onload = function () {
            ctx.drawImage(img, 0, 0, 150, 100);
            setTimeout(() => printWindow.print(), 300);  // Slight delay to ensure image loads fully
        };

        // Fallback in case logo fails to load
        img.onerror = () => {
            console.error("Logo failed to load. Please check the path or file.");
            printWindow.print();
        };
    };
};

export default printInvoice;